export default __webpack_public_path__ + "static/combineSectionBg-68b59daac718dc878441005f7c7aeb45.png";